var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCssIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 296297 333333",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id4",
    gradientUnits: "userSpaceOnUse",
    x1: 54128.7,
    y1: 79355.5,
    x2: 240318,
    y2: 79355.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id5",
    gradientUnits: "userSpaceOnUse",
    x1: 62019.3,
    y1: 202868,
    x2: 233515,
    y2: 202868
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8e7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id6",
    gradientUnits: "userSpaceOnUse",
    x1: 104963,
    y1: 99616.9,
    x2: 104963,
    y2: 171021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id7",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#id6",
    x1: 194179,
    y1: 61185.8,
    x2: 194179,
    y2: 135407
  }), /*#__PURE__*/React.createElement("mask", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    x1: 104963,
    y1: 99616.9,
    x2: 104963,
    y2: 171021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.831,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id1)",
    d: "M61737 99467h86453v71704H61737z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "id3",
    gradientUnits: "userSpaceOnUse",
    x1: 194179,
    y1: 61185.8,
    x2: 194179,
    y2: 135407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.831,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id3)",
    d: "M147890 61036h92578v74521h-92578z"
  })), /*#__PURE__*/React.createElement("style", null, ".fil6{fill:#000;fill-opacity:.05098}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_513085304"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2062af",
    d: "M268517 300922l-120369 32411-120371-32411L0 0h296297z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c9cd7",
    d: "M148146 24374v283109l273 74 97409-26229 22485-256954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M148040 99617l-86153 35880 2857 35524 83296-35614 88604-37883 3674-36339-92278 38432z"
  }), /*#__PURE__*/React.createElement("path", {
    mask: "url(#id0)",
    fill: "url(#id6)",
    d: "M61887 135497l2857 35524 83295-35614V99617z"
  }), /*#__PURE__*/React.createElement("path", {
    mask: "url(#id2)",
    fill: "url(#id7)",
    d: "M240318 61186l-92278 38431v35790l88604-37883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id5)",
    d: "M62019 135497l2858 35524 127806 407-2859 47365-42055 11840-40428-10208-2450-29399H67327l4900 56756 75950 22457 75538-22050 9800-112692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M148040 135497H61888l2857 35524 83295 266v-35790zm0 95022l-408 114-40422-10208-2450-29399H67197l4899 56756 75944 22457v-39720z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#id4)",
    d: "M54129 61186h186189l-3674 36339H58620l-4491-36339z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil6",
    d: "M148040 61186H54129l4491 36339h89420z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssIcon);
export default __webpack_public_path__ + "static/media/css-icon.dbd31fe14ec796185689723739441965.svg";
export { ForwardRef as ReactComponent };